import {
  PROJECT_ALL,
  PROJECT_DELETE,
  PROJECT_GET,
  PROJECT_LOADING,
  PROJECT_POST,
  PROJECT_PUT,
} from '../type';
const initialState = {
  Product: null,
  isLoading: true,
  isCompleted: true,
};

function ProjectReducer(state = initialState, action) {
  switch (action.type) {
    case PROJECT_LOADING:
      return { isLoading: true, isCompleted: false };
    case PROJECT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PROJECT_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PROJECT_POST:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PROJECT_PUT:
      return {
        isLoading: false,
        isCompleted: true,
      };
    case PROJECT_DELETE:
      return {
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}

export default ProjectReducer;
